import React, { Component } from 'react'
import styled from 'styled-components'

class measureShare extends Component {
  render() {
    const { measureResult } = this.props.match.params
    const textColor = this.props.location.hash
    const value = measureResult.split(':')[1]
    let bgImage
    let text = ''
    if (textColor === '#10B79C') {
      bgImage = require('./images/bgShare1.png')
      text = '血糖正常'
    } else if (textColor === '#FE4F53') {
      bgImage = require('./images/bgShare3.png')
      text = '血糖较低'
    } else {
      bgImage = require('./images/bgShare2.png')
      text = '血糖偏高'
    }
    return (
      <RootView
        style={{
          backgroundImage: 'url(' + bgImage + ')',
        }}
      >
        <div
          style={{
            fontSize: 20,
            fontWeight: 'bold',
            color: 'rgba(51, 51, 51, 1)',
            textAlign: 'center',
            paddingTop: 150,
          }}
        >
          您的测量结果
        </div>
        <div
          style={{
            flexDirection: 'column',
            textAlign: 'center',
            paddingTop: 40,
          }}
        >
          <div
            style={{
              backgroundColor: textColor,
              width: '50%',
              margin: '0 auto',
              padding: 10,
              borderBottomRightRadius: 16,
              borderTopLeftRadius: 16,
            }}
          >
            <div style={{ color: 'white', fontSize: 40, fontWeight: 'bold' }}>
              {text}
            </div>
          </div>
          <div
            style={{
              marginTop: 25,
              color: textColor,
              fontSize: 18,
            }}
          >
            {`血糖数值为 ${value} mmol/L`}
          </div>
          <div
            style={{
              marginTop: 15,
              color: 'rgba(51, 51, 51, 1)',
              fontSize: 18,
            }}
          >
            请通过“共同照护”APP咨询医生
          </div>
          <div
            style={{
              fontSize: 18,
              width: '80%',
              textAlign: 'center',
              height: 50,
              lineHeight: '50px',
              position: 'absolute',
              bottom: '20%',
              left: '50%',
              marginLeft: '-40%',
              background: 'rgba(38, 197, 171, 1)',
              color: 'rgba(255, 255, 255, 1)',
              borderRadius: '4px',
            }}
            onClick={() => {
              window.location.href =
                'https://a.app.qq.com/o/simple.jsp?pkgname=com.ihealth.HuTang&fromcase=40002#fromopen&opened'
            }}
          >
            立即下载
          </div>
        </div>
      </RootView>
    )
  }
}

export default measureShare

const RootView = styled.div`
  width: 100%;
  height: calc(100vh - 10px);
  overflow: hidden;
  background-size: 100% 100%;
  background-repeat: no-repeat;
`



// WEBPACK FOOTER //
// ./src/modules/wechatShare/components/measureShare.js